import { Record } from 'immutable';
import VehicleModelV25 from 'commons-vehicle/Vehicle/models/VehicleModelV25';
import QuoteModelV25 from 'commons-vehicle/Quote/models/QuoteModelV25.js';
import { pick } from 'lodash';

const UpdateQuoteModel = Record({
    leadId: 0,
    accountId: 0,
    vehicleCondition: '',
    saleType: 'retail',
    taxPlan: 'standard',
    purchaseMethod: 'cash',
    financePlan: '',
    kmPerYearPlan: 0,
    paymentFrequency: 12,
    term: 0,
    cashDown: 0,
    tradeIn: 0,
    lien: 0,
    transactionToken: '',
    id: '',
    quoteRevision: '',
});

class UpdateQuoteModelV25 extends UpdateQuoteModel {
    constructor(modelDefaults) {
        if (modelDefaults) {
            super(modelDefaults);
        } else {
            super();
        }
    }
    setModelValuesFromQuoteModelV25(quoteModelV25) {
        if (!(Object.getPrototypeOf(quoteModelV25) === Object.getPrototypeOf(new QuoteModelV25()))) {
            throw new Error('setModelValuesFromQuoteModelV25 expecting instance of QuoteModelV25');
        }

        return this.setModelValuesFromVehicleModelV25(quoteModelV25.vehicle)
            .set('accountId', quoteModelV25.accountId)
            .set('leadId', quoteModelV25.leadId)
            .set('id', quoteModelV25.id)
            .set('quoteRevision', quoteModelV25.quoteRevision);
    }

    setModelValuesFromVehicleModelV25(vehicleModelV25) {
        if (!(Object.getPrototypeOf(vehicleModelV25) === Object.getPrototypeOf(new VehicleModelV25()))) {
            throw new Error('setModelValuesFromVehicleModelV25 expecting instance of VehicleModelV25');
        }

        const keys = Object.keys(this.toObject());
        const toMerge = pick(vehicleModelV25.toObject(), keys);

        return this.merge({
            ...toMerge,
            saleType: vehicleModelV25.purchaseMethods.saleType,
            taxPlan: vehicleModelV25.purchaseMethods.taxPlan,
            purchaseMethod: vehicleModelV25.purchaseMethods.purchaseMethod,
            financePlan: vehicleModelV25.purchaseMethods.financePlan,
            kmPerYearPlan: vehicleModelV25.purchaseMethods.kmPerYearPlan,
            paymentFrequency: vehicleModelV25.purchaseMethods.paymentFrequency,
            term: vehicleModelV25.purchaseMethods.term,
            cashDown: vehicleModelV25.purchaseMethods.cashDown,
            tradeIn: vehicleModelV25.purchaseMethods.tradeIn,
            lien: vehicleModelV25.purchaseMethods.lien,
            transactionToken: vehicleModelV25.purchaseMethods.transactionToken,
        });
    }
}

export default UpdateQuoteModelV25;
